module.exports = __webpack_public_path__ + "static/media/arrow-up-right.cea28d20.svg";